<template>
    <div id="horizontal-rule" v-show="hasSearched">
        <hp5-spacing-vertical xs="xs"></hp5-spacing-vertical>
        <hp5-horizontal-rule id="horizontal-rule" style-selection="pattern"></hp5-horizontal-rule>
        <hp5-spacing-vertical xs="lg"></hp5-spacing-vertical>
    </div>
</template>

<script setup>
    const { hasSearched } = useFCPModel()
</script>